// extracted by mini-css-extract-plugin
export default {"card":"m4-z"};